import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import Header from "../layout/Header";
import BannerGiveawayDetails from "../common/BannerGiveawayDetails";
import GiveawayDetailsStatic from "components/common/GiveawayDetailsStatic";

// Public giveaway details page: reuses the site Header + hero banner
// from the /Giveaway listing page (Header is position:absolute and
// floats on top of the banner - it needs that banner underneath it
// for spacing/background, otherwise it overlaps whatever comes next),
// with the static Giveaway Details layout rendered below.
function GiveawayDetailsPage() {
  return (
    <div className="App">
      <Header />
      <BannerGiveawayDetails />
      <GiveawayDetailsStatic />
    </div>
  );
}

export default GiveawayDetailsPage;
